import { render, staticRenderFns } from "./NewBranchAdd.vue?vue&type=template&id=3190b3eb&scoped=true"
import script from "./NewBranchAdd.vue?vue&type=script&lang=js"
export * from "./NewBranchAdd.vue?vue&type=script&lang=js"
import style0 from "./NewBranchAdd.vue?vue&type=style&index=0&id=3190b3eb&prod&lang=scss&scoped=true"
import style1 from "./NewBranchAdd.vue?vue&type=style&index=1&id=3190b3eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3190b3eb",
  null
  
)

export default component.exports